export enum UIStates {
    DEFAULT = 'DEFAULT',
    IDLE = 'IDLE',
    ERROR = 'ERROR',
    SPIN = 'SPIN',
    STOP_SPIN = 'STOP_SPIN',
    SPIN_RESULT = 'SPIN_RESULT',
    SPIN_END = 'SPIN_END',
    FREE_SPINS = 'FREE_SPINS',
    AUTO = 'AUTO',
    AUTO_STOP = 'AUTO_STOP',
    BONUS = 'BONUS',
    WIN = 'WIN',
    HIDDEN = 'HIDDEN',
    BIG_WIN = "BIG_WIN",
    PICKSCREEN = "PICKSCREEN"
}

export enum UIModes {
    DEFAULT = "DEFAULT",
    BONUS = "BONUS",
    GAMBLE = "GAMBLE",
    FREE_SPINS = 'FREE_SPINS',
    AUTO = 'AUTO',
    PROMOTION_SPINS = 'PROMOTION_SPINS',
    RESPINS = "RESPINS"
}